<template>
    <div>
        <!-- A2P Messaging Profile Information -->
        <div v-if="row.a2p_messaging_profile">
            <div>
                <strong>Company Type:</strong> {{ getCompanyType }}
            </div>
            <template v-if="isPublicCompany">
                <div class="mt-1">
                    <strong>Stock Ticker:</strong> {{ getStockTicker }}
                </div>
                <div>
                    <strong>Stock Exchange:</strong> {{ getStockExchange }}
                </div>
                <div>
                    <strong>Brand Contact Email:</strong> {{ getBrandContactEmail }}
                </div>
            </template>
        </div>
        <!-- Voice Integrity Information -->
        <div v-else-if="row.voice_integrity_end_user">
            <div>
                <strong>Use Case:</strong> {{ getUseCase }}
            </div>
            <div class="mt-1">
                <strong>Business Employee Count:</strong> {{ getBusinessEmployeeCount }}
            </div>
            <div class="mt-1">
                <strong>Average Business Day Call Volume:</strong> {{ getAverageBusinessDayCallVolume }}
            </div>
            <div v-if="getNotes" class="mt-1">
                <strong>Notes:</strong> {{ getNotes }}
            </div>
        </div>
        <div v-else>
            <span class="text-muted">No information available</span>
        </div>
    </div>
</template>

<script>
import { PRIVATE, PUBLIC } from '../../../constants/company'

export default {
    name: 'AttributesColumn',
    props: {
        row: {
            type: Object,
            required: true,
        },
    },
    computed: {
        getCompanyType() {
            if (!this.row.a2p_messaging_profile) {
                return 'Unknown'
            }

            return this.row.a2p_messaging_profile?.bundle_attributes?.company_type === PRIVATE ? 'Private' : 'Public'
        },
        isPublicCompany() {
            return this.row.a2p_messaging_profile?.bundle_attributes?.company_type === PUBLIC
        },
        getStockTicker() {
            return this.row.a2p_messaging_profile?.bundle_attributes?.stock_ticker || 'N/A'
        },
        getStockExchange() {
            return this.row.a2p_messaging_profile?.bundle_attributes?.stock_exchange || 'N/A'
        },
        getBrandContactEmail() {
            return this.row.a2p_messaging_profile?.bundle_attributes?.brand_contact_email || 'N/A'
        },
        getUseCase() {
            return this.row.voice_integrity_end_user?.bundle_attributes?.use_case || 'N/A'
        },
        getBusinessEmployeeCount() {
            return this.row.voice_integrity_end_user?.bundle_attributes?.business_employee_count || 'N/A'
        },
        getAverageBusinessDayCallVolume() {
            return this.row.voice_integrity_end_user?.bundle_attributes?.average_business_day_call_volume || 'N/A'
        },
        getNotes() {
            return this.row.voice_integrity_end_user?.bundle_attributes?.notes || null
        }
    }
}
</script>
